import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 查询资格购活动列表
   */
  static getQualificationList(data) {
    return Request({
      url: 'promotion/queryActiveActivity/qualification/validate',
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/QualificationPage/QualificationPageServ.js